import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGrayscale = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "M24 43.778c-9.022 0-16.09-6.854-16.09-15.604 0-10.821 7.302-17.758 15.193-23.642L24 3.864l.896.669c7.891 5.884 15.193 12.82 15.193 23.642.001 8.75-7.067 15.603-16.089 15.603m0-36.165c-6.911 5.269-13.09 11.455-13.09 20.562 0 7.067 5.75 12.604 13.09 12.604s13.089-5.536 13.089-12.604C37.09 19.07 30.911 12.882 24 7.613" }), /* @__PURE__ */ _jsx("path", { d: "M24 10.781v27.284c-5.944 0-10.6-4.457-10.6-10.147 0-7.059 4.169-12.076 10.6-17.137" })] }) })
});
export default SvgGrayscale;
